import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Topbar from './components/Topbar';
import Sidebar from "./components/Sidebar";
import Loading from '../../admin/components/Loading';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from "mdbreact";

const mySwal = withReactContent(Swal);

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            toggled: false,
            data: []
        };
    };

    componentDidMount() {
        axios
            .post("/api/client/dashboard", { clientId: this.props.client.clientId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
            .then(res => {
                this.setState({
                    ...this.state,
                    loading: false,
                    data: res.data.data
                });
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    loading: false
                });
                mySwal.fire("Error", err.response.data.error, "error");
            });
    }

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    render() {

        let tableData = {
            columns: [
                {
                    label: "Username",
                    field: "username",
                    sort: "asc"
                },
                {
                    label: "Total Users Registered",
                    field: "users",
                    sort: "asc"
                },
                {
                    label: "Total Active Outlets",
                    field: "outlets",
                    sort: "asc"
                },
                {
                    label: "Total Vouchers Given",
                    field: "vouchers",
                    sort: "asc"
                },
                {
                    label: "Total Transaction Counts",
                    field: "transactions",
                    sort: "asc"
                }
            ],
            rows: this.state.data
        };

        if (this.props.client.stamp) {
            tableData.columns.push({
                label: "Total User Stamps Collected",
                field: "stamps",
                sort: "asc"
            })
        }

        return (
            <div id="admin-dashboard" className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />

                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />

                    <div className="admin-content">
                        <div className="text-center">
                            <h3>Welcome</h3>
                        </div>

                        <div className="mt-5">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between">
                                    <h5 className="card-title">Dashboard</h5>
                                </div>

                                <div className="card-body text-center">
                                    {
                                        this.state.loading ? <Loading /> : <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    };
};

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

export default connect(mapStateToProps, null)(Dashboard);